import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themePreference, setThemePreference] = useState(() => {
    try {
      const stored = localStorage.getItem('app_theme_preference');
      if (['dark', 'light', 'system'].includes(stored)) return stored;
      
      // Migration from old app_theme
      const oldStored = localStorage.getItem('app_theme');
      if (oldStored === 'dark') return 'dark';
    } catch (e) {
      // ignore
    }
    return 'system';
  });

  const [actualTheme, setActualTheme] = useState('light');

  useEffect(() => {
    const updateTheme = () => {
      let resolvedTheme = themePreference;
      if (themePreference === 'system') {
        resolvedTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      }
      setActualTheme(resolvedTheme);

      const root = document.documentElement;
      if (resolvedTheme === 'dark') {
        root.classList.add('theme-dark');
        root.classList.remove('theme-light');
      } else {
        root.classList.add('theme-light');
        root.classList.remove('theme-dark');
      }

      try { localStorage.setItem('app_theme_preference', themePreference); } catch (e) {}

      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) {
        meta.setAttribute('content', resolvedTheme === 'dark' ? '#000000' : '#ffffff');
      }
    };

    updateTheme();

    if (themePreference === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => updateTheme();
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
      } else if (mediaQuery.addListener) { // Safari fallback
        mediaQuery.addListener(handleChange);
        return () => mediaQuery.removeListener(handleChange);
      }
    }
  }, [themePreference]);

  const setTheme = (value) => {
    if (!['dark', 'light', 'system'].includes(value)) return;
    setThemePreference(value);
  };

  const toggleTheme = () => {
    setThemePreference(actualTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme: actualTheme, themePreference, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
